import React, { useState } from "react"
import { Col, Form, Button } from "react-bootstrap"
import { BiMailSend } from "react-icons/bi"
import addToMailchimp from "gatsby-plugin-mailchimp"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const ContactForm = () => {
  const [formData, setFormData] = useState({})
  const [validated, setValidated] = useState(false)
  const [sent, setSent] = useState(false)

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value })

  const sendToMailchimp = async () => {
    const email = formData.email

    const listFields = {
      FNAME: formData.firstname,
      LNAME: formData.lastname,
      COMMENT: formData.message,
    }

    const result = await addToMailchimp(email, listFields)
    console.log(result)
  }

  const handleSubmit = e => {
    e.preventDefault()
    setValidated(true)
    const form = e.currentTarget

    if (form.checkValidity() === false) {
      e.stopPropagation()
    } else {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": form.getAttribute("name"),
          ...formData,
        }),
      }).catch(error => alert(error))

      sendToMailchimp()

      setSent(true)
      setValidated(false)
      form.reset()
    }
  }

  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
      method="post"
      netlify-honeypot="bot-field"
      data-netlify="true"
      name="contact"
    >
      <input type="hidden" name="form-name" value="contact" />

      <p hidden>
        <label>
          Don’t fill this out: <input name="bot-field" onChange={onChange} />
        </label>
      </p>

      <Form.Row>
        <Form.Group as={Col} lg="6" controlId="formGroupFirstName">
          <Form.Label>1. First name</Form.Label>
          <Form.Control
            type="text"
            required
            name="firstname"
            onChange={onChange}
          />
          <Form.Control.Feedback type="invalid">
            Please enter your first name.
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} lg="6" controlId="formGroupLastName">
          <Form.Label>2. Last name</Form.Label>
          <Form.Control
            type="text"
            required
            name="lastname"
            onChange={onChange}
          />
          <Form.Control.Feedback type="invalid">
            Please enter your last name.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} controlId="formGroupEmail">
          <Form.Label>3. Email</Form.Label>
          <Form.Control
            required
            onChange={onChange}
            type="email"
            name="email"
          />
          <Form.Control.Feedback type="invalid">
            Please enter your email.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} controlId="formGroupMessage">
          <Form.Label>4. Message</Form.Label>
          <Form.Control
            onChange={onChange}
            as="textarea"
            rows="4"
            name="message"
          />
          <Form.Control.Feedback type="invalid">
            Please enter your email.
          </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>

      <Form.Group>
        <Button type="submit" variant="powder">
          Let's do this!
          <BiMailSend className="ml-2" />
        </Button>
        {sent && (
          <div className="mt-2 text-gold">
            Thank you, will be in touch soon!
          </div>
        )}
      </Form.Group>
    </Form>
  )
}

export default ContactForm
